import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-enter",
  "use": "arrow-enter-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"arrow-enter\"><path d=\"M10.88 20.29l1.41 1.42L18 16l-5.71-5.71-1.41 1.42L14.17 15H0v2h14.17l-3.29 3.29z\" /><path d=\"M8 4v4h2V6h20v20H10v-2H8v4h24V4H8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/arrow-enter.svg
// module id = LWsg
// module chunks = 39 44